import { render, staticRenderFns } from "./user-wizard-grouping.vue?vue&type=template&id=6a2a65f0"
import script from "./user-wizard-grouping.vue?vue&type=script&lang=js"
export * from "./user-wizard-grouping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports